import React, {useState} from "react";
import '../components/styles.css'
import { useNavigate } from "react-router-dom";




export default function ForgotPassword(){
    
    const [email, setEmail] = useState();
    const navigate = useNavigate();

    const handlePasswordReset = async(event) =>{
            event.preventDefault();
            const baseURL = process.env.REACT_APP_BASEURL;
            const url  = baseURL + "resetpassword";
            try{
                const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({email}),
                });
                 
                if (response.ok) {
                        const data = await response.json();
                        alert(data.detail);
                        setTimeout(() => {navigate("/login");}, 5000);
                } else {
                        const data = await response.json();
                        alert(data.detail); // Display any error message from the backend
                    }
                } catch (error) {
                    alert(error.message);
            }
            
    }
    
    return( 
        <div className = "form-container">
           <form id= "login-form" className = "form-card">
                <p className="form-header">Confirm Email</p>
                <input className = "form-input" onChange = {(e) => setEmail(e.target.value)} type="email" placeholder="Enter your email address" required></input>
                <button onClick = {handlePasswordReset} className = "form-submit-button">Confirm</button>
                        
           </form>
        </div>
        
    )
    
}